/** SPIN ids are UUIDv7: the leading hex is a timestamp shared by SPINs minted in one run, so show the random tail. */
export const shortSpinId = (id: string): string => id.slice(-8)
